// Video iframe code below, Arquib to remove when all old popup videos are removed.
    window.addEventListener("DOMContentLoaded", function () {
        window.setTimeout(loadVideoPopups, 200); //push to last to avoid conflict with widon't
    });
function loadVideoPopups() {
    if ($(".popup-youtube, .popup-vimeo, .popup-gmaps").length == 0) return;

    $(".popup-youtube, .popup-vimeo, .popup-gmaps").on("click", function (e) {
        e.preventDefault();
        var width = $(window).width();
        if (width > 768) {
            openSimpleIframeModalDialog($(this).attr('href'), "video-modal");
        } else if ($(this).is('.popup-youtube')) {
            var target = $(this).attr('data-video');
            self.location = target;
        }
    });

    function openSimpleIframeModalDialog(href, className) {
        $('body').append(
            `<div class="modal ${className}" id="dynamic-video-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
				            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">x</span>
                            </button>
					        <div class="video-spinner"><div id="loading"><!----></div></div>
                        <iframe src="${href}" style="width: 100%; height: 100%"></iframe>
                    </div>
                </div>
            </div>`
        );
        $("#dynamic-video-modal").modal().on('hidden.bs.modal', function () { $("#dynamic-video-modal").remove() });
        var opts = {
            lines: 12, // The number of lines to draw
            length: 7, // The length of each line
            width: 4, // The line thickness
            radius: 10, // The radius of the inner circle
            color: '#fff', // #rgb or #rrggbb
            speed: 1, // Rounds per second
            trail: 60, // Afterglow percentage
            shadow: false, // Whether to render a shadow
            hwaccel: false // Whether to use hardware acceleration
        };
        var spinner = new Spinner(opts).spin($('.video-spinner #loading')[0]);
    }
};